require.register("app/restaurant/ShowView", function(exports, require, module){
  $0
  
});

